export default __webpack_public_path__ + "static/media/no-connections.9e66064c.svg";